import { WorkflowGroup, WorkflowLogItem } from 'vopay';
import { useState } from 'react';
import apiConfig from '@/services/api.config';
import useTransactionApprovalAccess from '@/hooks/useTransactionApprovalAccess';

const { api } = apiConfig;

export default function useFetchWorkflows({ bearer }: { bearer?: string } = {}) {
  const [workflows, setWorkflows] = useState<WorkflowGroup[]>([]);
  const [fetchingWorkflows, setFetchingWorkflows] = useState(false);
  const [workflowLogs, setWorkflowLogs] = useState<WorkflowLogItem[]>([]);
  const [fetchingWorkflowLogs, setFetchingWorkflowLogs] = useState(false);
  const canUseTransactionApproval = useTransactionApprovalAccess();

  async function fetchWorkflows(bearerToken?: string) {
    if (!bearerToken && !canUseTransactionApproval) {
      return;
    }

    try {
      setFetchingWorkflows(true);
      const res = await api.fetchWorkflows(undefined, bearerToken ?? bearer);

      if (!res.Success) throw new Error(res.ErrorMessage);
      setWorkflows(res.Workflows);

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingWorkflows(false);
    }
  }

  async function fetchWorkflowLogs(workflowID?: string) {
    if (!bearer && !canUseTransactionApproval) {
      return;
    }

    try {
      setFetchingWorkflowLogs(true);
      const res = await api.fetchWorkflowLogs({ WorkflowID: workflowID }, undefined, bearer);

      if (!res.Success) throw new Error(res.ErrorMessage);
      setWorkflowLogs(res.Logs);
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingWorkflowLogs(false);
    }
  }

  return {
    workflows,
    fetchWorkflows,
    fetchingWorkflows,
    workflowLogs,
    fetchWorkflowLogs,
    fetchingWorkflowLogs,
  };
}
